<template>
  <div class="step-indicator">
    <div class="step-item" :class="{ active: currentStep === 1, completed: currentStep > 1 }">
      <div class="step-number">1</div>
      <span>{{ step1Label }}</span>
    </div>
    <div class="step-item" :class="{ active: currentStep === 2 }">
      <div class="step-number">2</div>
      <span>{{ step2Label }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TwoFactorStepIndicator',
  props: {
    currentStep: {
      type: Number,
      required: true,
      validator: value => [1, 2].includes(value)
    },
    step1Label: {
      type: String,
      default: 'Escanear QR'
    },
    step2Label: {
      type: String,
      default: 'Verificar'
    }
  }
};
</script> 